import { buildAgentQuestionAssistantMessagePatch } from '../agentQuestion/buildAgentQuestionAssistantMessagePatch.js'

/** @param {import('./runResponseComponentDemoStream.js').DemoStreamCtx} ctx */
export function runAgentQuestionTurn(ctx) {
  const { tid, pendingId, signal, session, setMessagesByThreadId } = ctx

  session.addTimeout(() => {
    if (signal.aborted) {
      session.dispose()
      return
    }
    setMessagesByThreadId((inner) => {
      const list = [...(inner[tid] ?? [])]
      const idx = list.findIndex((m) => m.id === pendingId)
      if (idx === -1) return inner
      const prev = list[idx]
      const patch = buildAgentQuestionAssistantMessagePatch(
        prev.thinkingStartedAt ?? prev.createdAt,
      )
      list[idx] = { ...prev, ...patch }
      return { ...inner, [tid]: list }
    })
    session.dispose()
  }, 500)
}
